import { faGoogle, faReact } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import TS from './../Icons/typescriptlang.svg'
import { CustomIcon, HowItsMadeBody, HowItsMadeHeader, StyledLink, TextContainer } from "./StyledComponents"

const packages = ['Material UI', 'Emotion Styled Components', 'React-Spring']

const How: React.FC = () => {
    return (
        <TextContainer>
            <HowItsMadeHeader>How did this get made?</HowItsMadeHeader>
            <HowItsMadeBody>
                Usually, we try to avoid how the sausage is made... but you're different...
            </HowItsMadeBody>
            <HowItsMadeBody>
                This page is built using <StyledLink href="https://reactjs.org/"><FontAwesomeIcon icon={faReact} size="sm" color="black" />React</StyledLink>,
                written in <StyledLink href="https://www.typescriptlang.org/"><CustomIcon src={TS} height={25} width={25} alt="Typescript" />Typescript</StyledLink>, and hosted on the <StyledLink href="https://cloud.google.com/">
                <FontAwesomeIcon icon={faGoogle} size="sm" color="black" />oogle Cloud Platform (GCP)</StyledLink>, but that doesn't tell the whole story. 
            </HowItsMadeBody>
            <HowItsMadeBody>
                This is all possible thanks to these packages: Coming soon...
            </HowItsMadeBody>
        </TextContainer>
    )
}

export default How